import React from "react";

const faces = ["front", "back", "right", "left", "top", "bottom"];

function Scene() {
  return (
    <div className="scene" aria-hidden="true">
      <div className="cube">
        {faces.map((face) => (
          <span key={face} className={`cube-face ${face}`} />
        ))}
      </div>
    </div>
  );
}

export default Scene;
